export default import.meta.ROLLDOWN_FILE_URL_A1Zs0VgGbFRHOHpdguoNIw